module.exports = __webpack_public_path__ + "static/media/icn_filter.efd8f552.svg";